module.exports = __webpack_public_path__ + "static/img/icon_rock_bg@2x.eb268a8b.png";